// iOS < 10 support
if (typeof Intl === 'undefined' || !('NumberFormat' in Intl)) {
  const lang = (window.location.pathname.match(/^\/?([a-z]{2})-([a-z]{2})/) || [])[1]
  const script = document.createElement('script')
  script.src =
    'https://polyfill.io/v3/polyfill.min.js?features=Intl.NumberFormat,Intl.NumberFormat.~locale.' +
    lang +
    ',Intl.DateTimeFormat,Intl.DateTimeFormat.~locale.' +
    lang
  document.head.appendChild(script)
}
